// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__1kFcE","navText":"Navbar_navText__1cMyX","navLogo":"Navbar_navLogo__3rqhj","imgLogo":"Navbar_imgLogo__1f2bd"};